<template>
  <generic-modal :title="$t('identification condition')" ref="generic_modal">
    <form>
      <div class="columns">
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("active type") }}</label>
            <div class="control">
              <input class="input" type="text" v-model="meta.active_type" />
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("warranty type") }}</label>
            <div class="control">
              <input class="input" type="text" v-model="meta.warranty_type" />
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("segment") }}</label>
            <div class="control">
              <input class="input" type="text" v-model="meta.segment" />
            </div>
          </div>
        </div>
      </div>
    </form>
    <div class="notification is-danger mt-5" v-if="error">
      <p v-html="error"></p>
    </div>
    <template v-slot:footer>
      <button
        class="button is-primary is-rounded"
        @click="save"
        :disabled="is_form_invalid"
      >
        <span class="icon">
          <i class="fa fa-save"></i>
        </span>
        <span>{{ $t("save") }}</span>
      </button>
      <button class="button is-rounded" @click="close_modal">
        <span class="icon">
          <i class="fa fa-close"></i>
        </span>
        <span>{{ $t("cancel") }}</span>
      </button>
    </template>
  </generic-modal>
</template>
<script>
import {
  put,
  error_message,
  get,
  post,
  error_alert,
  generate_error_message_text,
  get_currency_settings,
} from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";

export default {
  name: "DebtLevelModal",
  components: { GenericModal },
  data() {
    return {
      meta: {},
      error: "",
    };
  },
  computed: {
    is_form_invalid() {
      let v = this;
      // return false;
      return !v.meta.active_type;
    },
  },
  methods: {
    close_modal() {
      let v = this;
      v.$refs.generic_modal.close_modal();
      v.set_initial_state();
    },
    create(type) {
      let v = this;
      v.set_initial_state();
      v.meta.type = type;
      v.$refs.generic_modal.show_modal();
    },
    // edit_modal(uuid) {
    //   let v = this;
    //   v.set_initial_state();

    //   get("/debt-level", { uuid: uuid })
    //     .then((element) => {
    //       v.meta = element;
    //       v.$refs.generic_modal.show_modal();
    //     })
    //     .catch((error) => {
    //       v.error = generate_error_message_text(error);
    //     });
    // },
    save() {
      let v = this;
      v.$emit("save", v.meta);
      v.close_modal();
    },
    set_initial_state() {
      let v = this;
      v.meta = {};
      v.error = "";
      // v.uuid = "";
    },
  },
  mounted() {},
  watch: {},
};
</script>
<style></style>
